document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    if (!document.body.hasAttribute("data-pdm-purchase-section")) {
      return;
    }

    observer.disconnect();

    const changeProductSection = () => {
      const $productsSection = document.querySelector(
        ".product__collection-products",
      );
      const $productDescription = document.querySelector(
        ".product__description",
      );

      console.log(
        "pdm change product section",
        $productDescription,
        $productsSection,
      );

      $productDescription.parentNode.insertBefore(
        $productsSection,
        $productDescription.nextElementSibling,
      );
    };

    changeProductSection();

    subscribe(PUB_SUB_EVENTS.optionValueSelectionChanged, () => {
      console.log("pdm change ocurred here");
      changeProductSection();
    });
  });
  observer.observe(document.body, {
    attributes: true,
    childList: false,
    subtree: false,
  });
});
